import './header.scss';
import React, { Component } from 'react';
import { NavLink, Route } from 'react-router-dom';
import Assets from './../../requests/apa/Asset';
import Translator from './../../requests/apa/Translator';
import Metadata from '../../requests/apa/Metadata';
import focusSettings from './../Focus/settings';
import { connect } from 'react-redux';
import { showModal, MODAL_PROFILE, MODAL_KEYBOARD, AAF_MODAL_ERROR, MODAL_FILTER } from '../../actions/modal';
import CCOM from '../../devices/nagra/CCOM';
import PropTypes from 'prop-types';
import Utils, { isEnabledCenterNotifications, setContainerHeight, setContainerHeightWhenCenterNotifcationIsEnabled } from '../../utils/Utils';
import UtilsProfile from '../../utils/Profile';
import { setMetricsEvent } from '../../actions/metrics';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import clarotv_logo from './clarotv.png';
import UtilsIpTelmex from '../../utils/user/IpTelmex';
import UtilsIsLoggedIn from '../../utils/user/isLoggedIn';
import ActivesSingleton from './ActivesSingleton';
import AnalyticsDimensionSingleton from './AnalyticsDimensionSingleton';
import Device from '../../devices/device';
import LayersControl from '../../utils/LayersControl';
import { login } from '../../requests/loader';
import { fetchLinealChannels } from '../../actions/payway';
import { receiveIsLoggedIn } from '../../reducers/user';
import { setProfileData } from '../../reducers/profile';
import AAFPlayer from '../../AAFPlayer/AAFPlayer';
import { playFullMedia } from '../../actions/playmedia';
import store from '../../store';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import utilsIsSticky from '../../utils/user/IsSticky';
import BlockedChannels from '../../utils/BlockedChannels';
import channelBlockedUtil from '../../utils/ChannelBlockedUtil';
import { AAFPLAYER_STOP, AAFPLAYER_PLAY, HOMEUSER } from '../../AAFPlayer/constants';
import { ALERT_ACTION_DEFAULT, ALERT_ACTION_IPTELMEX } from '../../containers/App/constants'
import { getDimensions } from '../../utils/analytics';
import FlagEventMini from '../PersistentMiniEpg/FlagEventMini';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import { HidePlayerControlsObserver } from '../PersistentMiniEpg/MiniObserver';
import { Alert } from '../../packages/components';
import settings from '../../devices/all/settings';
import {AAFMenu} from 'packages/components';
import { Avatar } from '../../packages/components';
import {getShowSoccerWorldCupNode} from '../../utils/Utils';
import { flagAlertBelt } from "../../actions/musica/alert-header-action";
import NewRelic from 'src/utils/trackers/NewRelic';
import AAF from '../../AAF/AAF';
import { AdsUtils } from '../../AAF/Ads/Utils';
import CenterNotification from '../centerNotification/CenterNotification';
import { toggleNotification } from '../../actions/centerNotifications';
import { METRIC_LABEL_PROFILE } from '../../components/Profile/constants';

const CLARO_MUSICA_NODE = 'claromusica';

class Header extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    nodes: PropTypes.arrayOf(PropTypes.object).isRequired,
    initialRoute: PropTypes.string.isRequired
  };

  static defaultProps = {
    user: {},
    nodes: [],
    initialRoute: 'homeuser'
  };

  constructor(props) {
    super(props);

    if (props.history){
      console.log(props.history)
      AAF.AdsUtils.recibeProps(props.history);
    }
    this.keys = Device.getDevice().getKeys();
    this.current = {}; // current selected node
    this.actives = []; // ids of selected elements for tracking parents of last node selected
    this.userBack = this.props && this.props.user;

    this.state = {
      menu: [],
      visibileElement: false,
      count_unread: 0,
      isAlertVisible: props.showAlert || props.history.location.showAlert,
      isAnonymousH: false,
      setChangeVisibilyAlertBelt: false,
      alertAction: this.userBack  && this.userBack.isSusc && !this.userBack.validEmail ? 2 : 1
    };

    this.headerContainerRef = null;
    this.CCOM = CCOM;
    this.nodes = Utils.filterNavNodes(this.getVisibleNodes(this.props.nodes,));
    this.allNodes = this.getAllNodes( this.nodes);
    const navcodes = this.allNodes.map(x => x.code);
    new ActivesSingleton().setNav(navcodes);
    this.setSelected = this.setSelected.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.refreshSession = this.refreshSession.bind(this);
    this.parseRefreshSession = this.parseRefreshSession.bind(this);
    this.stopPlayer = this.stopPlayer.bind(this);
    this.isANode = this.isANode.bind(this);
    this.getNextHeadersState = this.getNextHeadersState.bind(this);
    this.getActiveGA = this.getActiveGA.bind(this);
    this.isVcard = this.isVcard.bind(this);
    this.isMusicNode = this.isMusicNode.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.setAlertVisibility = this.setAlertVisibility.bind(this);
    this.onClickAlert = this.onClickAlert.bind(this);
    this.getNavMenu = this.getNavMenu.bind(this);
    this.getNavItems = this.getNavItems.bind(this);
    this.handleMenuFocus = this.handleMenuFocus.bind(this);
    this.handleMenuBlur = this.handleMenuBlur.bind(this);
    this.goPerfil = this.goPerfil.bind(this);
    this.handleImageLoad = this.handleImageLoad.bind(this)
    this.stickySuccess.bind(this);
    this.updateBlockedChannels.bind(this);

    this.musicFlag = null;
    this.homeFlag = null;
    this.counter = 0;
    this.mapa = {};
    this.oldNode = null;
    this.menuOnFocusPosition = 0;
    this.menuOnFocusLastPosition = 0;
    this.menuOnBlur = null;
    this.menuWidth = 0;
    this.isAnonymousStart = false;

    this.centerNotificationEnabled = isEnabledCenterNotifications()
  }

  getVisibleNodes(nodes){

    const { user: { isLoggedIn } = {} } = this.props;

    return nodes.filter((node) => {
      const { app_behaviour = false} = node;
      if (app_behaviour){
        const appBehaviour = JSON.parse(app_behaviour);
        const {node_config: {vis : {anon = 1, loggedin = 1} = {}} = {}} = appBehaviour || {};
        return isLoggedIn ? loggedin === 1:  anon === 1;
      }
      return true;
    });
  }

  getAllNodes(nodes) {
    let allNodes = [];
    nodes.forEach(node => {
      allNodes.push(node);
      if (node.childs && node.childs.length > 0) {
        const childs = this.getAllNodes(node.childs);
        allNodes = [...allNodes, ...childs];
      }
    }, this);
    return allNodes;
  }

  navNodesExtra(){
    const recur = (nodes, parent = '__root') => {
      nodes.map(x => {
        this.mapa[x.code] = { childs: x.childs ? x.childs : null, parent, text: x.text };
        if (x.childs) {
          recur(x.childs, x.code);
        }
      });
    };
    recur(this.nodes);
    const node = this.isANode();
    this.getNextHeadersState(node);

  }

  componentWillMount() {
    //Extraer todos los nodos del nav
    this.navNodesExtra();
  }
  componentDidMount() {

    //Listen email
    if (
      this.CCOM &&
      this.CCOM.ConditionalAccess &&
      this.CCOM.ConditionalAccess.addEventListener
    ) {
      CCOM.ConditionalAccess.addEventListener('onIrdMailNew', this.onSomeEvent);
    }

    this.addEventListeners();

    // Add class to large navbar container
    LayersControl.moveHeader();
    LayersControl.centerAAFMenu();

    if(this.centerNotificationEnabled && this.isHomeUserUrl()){
      setContainerHeightWhenCenterNotifcationIsEnabled(true, true)
    }else{
      // calculo del foco para el cintillo azul
      setContainerHeight(true, this.showAlertUserSuc());
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const currentNodes = prevState.menu;
    const newNodes = Utils.filterNavNodes(this.getVisibleNodes(prevProps.navbarNodes,));
    if (currentNodes.length !== newNodes.length) {
      this.setState({ menu: newNodes });
    } else if (JSON.stringify(currentNodes) !== JSON.stringify(newNodes)) {
      this.setState({ menu: newNodes });
    }

    clearTimeout(this.menuOnBlur);
    LayersControl.centerAAFMenu();

    if(this.centerNotificationEnabled && this.isHomeUserUrl()){
      setContainerHeightWhenCenterNotifcationIsEnabled(true, true)
    }else{
      // calculo del foco para el cintillo azul
      setContainerHeight(true, this.showAlertUserSuc());
    }
  }

  getNextHeadersState(node) {
    this.setState(
      {
        menu: this.nodes
      },
      () => {
        if (
          document.getElementById('header-down') &&
          document.getElementById('header-down').firstChild
        ) {
          document.getElementById(
            'header-down'
          ).firstChild.firstChild.style.marginLeft = `-${this.menuOnFocusPosition}px`;
        }
      }
    );
  }
  componentWillReceiveProps(nextProps) {
    const node = this.isANode();
    this.getNextHeadersState(node);
    const nodesStorage = store.getState().navbar.nodes || [];
    const newNodes = Utils.filterNavNodes(this.getVisibleNodes(nodesStorage,));

    if (this.props.nodes !== newNodes) {
      this.setState({ menu: newNodes });
    }

    if (
      this.props.history &&
      this.props.history.location &&
      nextProps.history &&
      nextProps.history.location
    ) {
      if (this.props.history.location.path !== nextProps.history.location.path) {
        this.counter = 0;
      }
      if(this.props.initialRoute && nextProps.initialRoute && this.props.initialRoute === 'search'  && nextProps.initialRoute === 'homeuser'){
        // Se basa en commit c9aafde linea 676.
        this.showAlert();
      }
    }
  }

  componentWillUnmount() {
    this.removeEventListeners();
    if(this.centerNotificationEnabled){
      setContainerHeightWhenCenterNotifcationIsEnabled(false, false);
    }else{
      setContainerHeight(false, false);
    }
    this.setState({ setChangeVisibilyAlertBelt: false });
  }

  handleKeyPress(e) {
    const pathname = window.location.pathname.split('/');
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;

    if (Utils.keyBloquedInPTV(pathname, currentKey)) {
      return;
    }

    const isPipPlaying = AAFPlayer.livePlayingAsPip();


    if (LayersControl.isPlayerVisible() && currentKey === 'RED' && !isPipPlaying) return;

    if (!Utils.isModalHide()) {
      return;
    }
    switch (currentKey) {
      case 'LIST':
        e.preventDefault();
        e.stopPropagation();
        const { changePath } = this.props;
        const { path, path_not_npvr = null } = Utils.getListButtonToggle();
        const userHasTs = ChannelSingleton.getMaxNpvrStorage();
        if (path && userHasTs > 0) {
          // Si tiene npvr y tiene llave path
          this.stopPlayer();
          changePath(path);
        }else if(path_not_npvr && userHasTs ===0){
          //Si no tiene npvr y tiene llave path_not_npvr
          this.stopPlayer();
          changePath(path_not_npvr);
        } else {
          this.stopPlayer();
          changePath('/user-settings/idioma');
          HidePlayerControlsObserver.fire();
        }
        break;
      case 'YELLOW':
        if(this.notEnableListeners()){
          return;
        }
        if (this.showAlertUserSuc()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.sendMetric('cerrar');
          this.hideAlert();
        }
        break;
      case 'GREEN':
        if(this.notEnableListeners()){
          return;
        }
        if (this.showAlertUserSuc()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.sendMetric('ok');
          this.onClickAlert();
        }
        break;
      default:
        break;
    }
  }

  notEnableListeners = () =>{
    return (LayersControl.isPlayerVisible() ||  !Utils.isNotificationHide());
  }

  onSomeEvent = e => {
    let messages = [];

    const filterByIdMethod = (data, id) => {
      const filterById = data.filter(it => it === id)[0];
      return filterById;
    };

    const msg = this.CCOM.ConditionalAccess.getIrdAllMail();
    if (Array.isArray(msg)) messages = Object.assign([], msg);
    else messages.push(msg.mailInfo);

    const DeviceStorageMessages = DeviceStorage.getItem('nagra_messages') || '[]';
    const unread_messages = JSON.parse(DeviceStorageMessages);

    messages.map(it => {
      const unread = filterByIdMethod(unread_messages, it.mailId);

      if (!unread) {
        this.setState({ count_unread: this.state.count_unread + 1 });
      }
    });
  };

  redirect = route => {
    this.props.history.push(`/${route}`);
  };

  refreshSession() {
    if (this.props.user && this.props.user.email && DeviceStorage.getItem('user_hash')) {
      login({ userhash: DeviceStorage.getItem('user_hash') })
        .then(this.parseRefreshSession)
        .catch(err => {
          console.log('error from refresh session' + err);
        });
    }
  }

  parseRefreshSession(result) {
    if (result && result.status === '0') {
      // Actualizar lista de suscripciones/paquetes que el user ha comprado/tiene acceso
      this.props.fetchLinealChannels(result.response.user_id);
      this.props.receiveIsLoggedIn(result.response);
      const region = DeviceStorage.getItem('region');
      DeviceStorage.setItem('user_hash', result.response.session_userhash);

      // Cerrar player
      const playerState = AAFPlayer.getCurrentPlayingState(false);
      // Si esta el full en pip, se cierra pip
      if (playerState === AAFPLAYER_PLAY) {
        this.props.playFullMedia({
          playerstate: AAFPLAYER_STOP,
          source: null,
          ispreview: false,
          islive: true,
          ispip: false,
          event: null
        });
      }
      // TODO lógica para dirigir a formulario de suscripción

      setTimeout(() => {
        if (region !== result.response.region) {
          DeviceStorage.setItem('region', result.response.region);
          window.location.href = '/';
        }
        else {
          this.props.history.push('/');
        }
      }, 1500);
    }
  }

  goValidateMail = (callback, userhash, resp) => {
    const modalProps = {
      onOmit: callback,
      userhash: userhash,
      phone: resp.userDetectWS && resp.userDetectWS.account ? resp.userDetectWS.account : ''
    };

    const modal = {
      modalType: MODAL_KEYBOARD,
      modalProps: {
        ...modalProps
      }
    };

    this.props.showModal(modal);
  };

  login(params) {
    const element = document.getElementsByClassName('app-profile-none');
    element[0].style['display']= 'block';
    login(params)
      .then(resp => {
        if (resp && resp.status === '0' || resp.status === 200 ) {
          this.successLogin = this.successLogin.bind(this);
          this.successLogin(resp.response);
          Utils.setCustomAttribute();
        }
      })
      .catch(err => {
        this.failLogin(err);
      });
  }

  async successLogin(response) {
    store.dispatch(receiveIsLoggedIn(response));
    const pushSession = Utils.getApaMetadataKey('sticky_session', '{"push_session":false,"user_id":false}', 'push_session');


    if (pushSession) {
      await utilsIsSticky.getPushSession(this.stickySuccess.bind(this), response);
    } else {
      this.stickySuccess(null, response).bind(this);
    }
  }

  stickySuccess(stickyResponse, response) {
    DeviceStorage.setItem('user_hash', response.session_userhash);
    if (response.user_id) {
      DeviceStorage.setItem('user_id', response.user_id);
      NewRelic.setUserId(response.user_id);
    }
    this.updateBlockedChannels();
    new ChannelSingleton().checkLinealChannels(() => {
      this.props.history.push('/');
    });
  }

  updateBlockedChannels() {
    const blockedChannelsList = new BlockedChannels();
    blockedChannelsList.checkBlockedChannels().then(response => {
      channelBlockedUtil.set('blockedChannels', response);
    });
  }

  stopPlayer() {
    try {
      const playerState = AAFPlayer.getCurrentPlayingState(false);

      if (playerState === AAFPLAYER_PLAY) {
        this.props.playFullMedia({
          playerstate: AAFPLAYER_STOP,
          source: null,
          ispreview: false,
          islive: true,
          ispip: false,
          event: null
        });
      }
    } catch (e) {
      console.error(e);
    }

    LayersControl.hidePlayer();
  }

  handleMouseEnter (e) {
    Utils.handleMouseEnter(e)
  }

  failLogin(response) {
    const modal = {
      modalType: AAF_MODAL_ERROR,
      modalProps: {
        callback: () => {
          //this.setIsLoading(false);
        },
        content: response.errors
      }
    };
    store.dispatch(showModal(modal));
  }

  addEventListeners() {
    document.addEventListener('keydown', this.handleKeyPress, true);
    if(this.centerNotificationEnabled) document.addEventListener('keydown', this.handleMenuKeyPress, true);
    document.addEventListener(settings.show_head_band, this.setAlertVisibility, true);
  }

  removeEventListeners() {
    document.removeEventListener('keydown', this.handleKeyPress, true);
    if(this.centerNotificationEnabled) document.removeEventListener('keydown', this.handleMenuKeyPress, true);
    document.removeEventListener(settings.show_head_band, this.setAlertVisibility, true);
  }

  handleMenuKeyPress = (e) => {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;

    if (currentKey === 'UP' && this.centerNotificationEnabled && this.isHomeUserUrl()) {
      // Verificar si el foco está en el menú
      const activeElement = document.activeElement;
      const isInMenu = activeElement && (
        activeElement.classList.contains('menu-item') ||
        activeElement.closest('.aaf_menu-container') ||
        activeElement.closest('.header-container')
      );

      if (isInMenu && !this.props.isOpen) {
        e.preventDefault();
        e.stopPropagation();
        this.props.toggleNotification();
      }
    }
  }

  setActiveElements() {
    this.props.setResumeDataEmpty();

    let node = this.isANode();
    if (!node) {
      this.actives = [];
      return;
    }

    this.actives = [];
    if (this.mapa[node]) {
      this.actives.push({ code: node, text: this.mapa[node].text });
      while (this.mapa[node].parent && this.mapa[node].parent !== '__root') {
        node = this.mapa[node].parent;
        this.actives.push({ code: node, text: this.mapa[node].text });
      }
    }
    new ActivesSingleton().setActives(this.actives);
    return;
  }

  getActiveGA(code = null) {
    let node = code;
    if (!node) {
      return;
    }

    let pathString = this.mapa[node].text;
    while (this.mapa[node].parent && this.mapa[node].parent !== '__root') {
      node = this.mapa[node].parent;
      pathString = this.mapa[node].text + '/' + pathString;
    }
    return pathString;
  }

  sendDimension() {
    const payload = new AnalyticsDimensionSingleton().getPayload();
    this.props.setMetricsEvent(payload);
    this.props.setMetricsEvent({ type: 'executor' });
  }

  sendMetric(label = null) {
    if (label === null) label = new ActivesSingleton().getTree();
    if (label === 'Registrate') {
      const dimensions = getDimensions();
      console.debug(dimensions);
      const analytics = new AnalyticsDimensionSingleton();
      this.props.setMetricsEvent({
        hitType: 'event',
        eventCategory: 'Top Menu',
        eventAction: 'Click',
        eventLabel: label,
        ...dimensions
      });
      this.props.setMetricsEvent({ type: 'executor' });
      this.props.setMetricsEvent({
        hitType: 'pageview',
        page: analytics.getPage(),
        ...dimensions
      });
      return;
    }
    if (label === 'ingresar') {
      this.props.setMetricsEvent({
        hitType: 'event',
        eventCategory: 'login',
        eventAction: 'click',
        eventLabel: 'click'
      });
      this.props.setMetricsEvent({ type: 'executor' });
    }
    this.props.setMetricsEvent({
      hitType: 'event',
      eventCategory: 'top menu',
      eventAction: 'click',
      eventLabel: label
    });
    this.props.setMetricsEvent({ type: 'executor' });
    this.sendDimension();
  }

  isANode() {
    if (
      this.props &&
      this.props.history &&
      this.props.history.location &&
      this.props.history.location.pathname
    ) {
      if (this.props.history.location.pathname.indexOf('/node/') === -1) {
        if ((this.isVcard() && this.oldNode) || (this.isMusicNode() && this.oldNode)) {
          return this.oldNode;
        }
        this.oldNode = null;
        //debugger
        return false;
      } else {
        const splitted = this.props.history.location.pathname.split('/node/');
        this.oldNode = splitted[1] ? splitted[1] : false;
        return this.oldNode;
      }
    }
  }

  isHomeUserUrl() {
    return window.location.pathname === "/node/homeuser";
  }

  isVcard() {
    if (
      this.props &&
      this.props.history &&
      this.props.history.location &&
      this.props.history.location.pathname
    ) {
      if (this.props.history.location.pathname.indexOf('/vcard/') === -1) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  }

  isMusicNode() {
    if (
      this.props &&
      this.props.history &&
      this.props.history.location &&
      this.props.history.location.pathname
    ) {
      if (
        this.props.history.location.pathname.indexOf('/playlist/') === 0 ||
        this.props.history.location.pathname.indexOf('/album/') === 0 ||
        this.props.history.location.pathname.indexOf('/radioList/') === 0 ||
        this.props.history.location.pathname.indexOf('/artist/') === 0
      ) {
        return true;
      }
    }
    return false;
  }

  showAlert() {
    this.setState({ isAlertVisible: true })
  }

  hideAlert(close = false) {
    const getShowAlertUserSuc = close === true ? this.showAlertUserSuc() : false;

    this.setState({ isAlertVisible: false });

    if (!Utils.isVisibleAlertHeaderBelt()) {
      this.hiddenAlertBeltHeader(getShowAlertUserSuc);
    }
  }

  hiddenAlertBeltHeader(statusAlertBelt) {
    if (statusAlertBelt && !this.state.setChangeVisibilyAlertBelt) {
      this.props.flagAlertBelt(true);
      this.setState({ setChangeVisibilyAlertBelt: true });
    }
  }

  changesVisibilityAlertBelt() {
    if (!this.state.setChangeVisibilyAlertBelt) {
      this.setState({ isAlertVisible: false, setChangeVisibilyAlertBelt: true });
    }
  }

  setAlertVisibility(data) {
    const { detail: { isAlertVisible, alertAction } = {} } = data || {};
    this.setState({ isAlertVisible, alertAction });
  }

  getAlertMessage() {
    const { alertAction = ALERT_ACTION_DEFAULT } = this.state;
    switch (alertAction) {
      case ALERT_ACTION_DEFAULT:
        return <span className='alert-action-default'>{Translator.get('home_ticker_mail_label', 'Bienvenido a Claro video. Da clic aquí para conocer más planes y acceder a canales Premium')}</span>;
      case ALERT_ACTION_IPTELMEX:
        return <span>{Translator.get('home_ticker_iptelmex_label', '¿Quieres ver Claro Video fuera de casa? Elije OK para registrar tu correo.')}</span>;
      default:
        return <span />;
    }
  }

  onClickAlert() {

    const { alertAction = ALERT_ACTION_DEFAULT } = this.state;

    this.hideAlert();

    switch (alertAction) {
      case ALERT_ACTION_DEFAULT:
        //USR07 - Home - registro con correo electrónico o número prepago
        this.props.history.push(`/${settings.path_suscription}`);
        break;
      case ALERT_ACTION_IPTELMEX:
        const { user: { firstname = '', lastname = '' }, user } = store.getState();
        const ipTelmexData = { ipTelmexData: { isTelmex: true, firstname, lastname } };
        this.props.history.push(`/${settings.path_register}`, ipTelmexData);
        break;
      default:
        this.props.history.push(`/${settings.path_suscription}`);
        break;
    }
  }

  shouldComponentUpdate(nextProps) {
    return true;
  }

  setSelected(selected = {}) {
    const porEnviar = this.getActiveGA(selected.code);
    if(selected.code === 'homeuser') this.showAlert();
    this.sendMetric(porEnviar);
    return;
  }



  enabledConfigSession() {
    let resp = false;
    const meta = Metadata.get('config_session', '{"default":{"enable":false}}');
    const objectMeta = JSON.parse(meta);
    const _region = DeviceStorage.getItem('region');
    const value = objectMeta[_region] ? objectMeta[_region] : objectMeta['default'];
    if (value && (typeof value === 'object') && value.hasOwnProperty("enable")) {
      resp = value.enable;
    }
    return resp;
  }

  goPerfil = () => {
    if (!this.props.user.isLoggedIn) return;
    const gamificationId = this.props.user.gamification_id;

    const platform = Device.getDevice().getPlatform();

    const enableSocialProfile = UtilsProfile.isSocialConfigEnable();

    const enableSessionRefresh = (this.enabledConfigSession() && platform === 'android');
    const enableAbout = false;
    // por agregar enableAbout para habilitar la seccion "Acerca de" desde APA
    const modal = {
      modalType: MODAL_PROFILE,
      modalProps: {
        gamificationId,
        enableSocialProfile,
        enableSessionRefresh,
        enableAbout,
        callback: (route, refreshSession, profile) => {
          if (profile) {
            this.stopPlayer();
            store.dispatch(
              setProfileData({
                profile
              })
            );
            const userhash = profile.user_hash;
            this.sendMetric('Ver Perfiles');
            this.login({
              userhash,
              includpaywayprofile: 'true'
            });
          } else if (refreshSession) {
            this.refreshSession();
          } else {
            if (route.includes('profile/admin')) {
              this.stopPlayer();
              this.sendMetric('Administrar Perfiles');
            }
            this.redirect(route);
          }
        },
        onMouseEnter: this.handleMouseEnter
      }
    };
    this.props.showModal(modal);
    this.sendMetric('perfil');
  };

  onAvatarClikHandler = () => {

    const { history, user: { isLoggedIn } = {} } = this.props;

    if (isLoggedIn) {
      // Descomentar para habilitar la nueva pantalla de perfil
      // history.push('/config'); 
      // this.sendMetric(METRIC_LABEL_PROFILE)
      this.goPerfil();
    }
    else {
      if(AdsUtils.isAdsEnable()){
        history.push('/login');
      }else{
        history.push('/landing');
      }

    }
  };


  onSearchClickHandler(e) {
    // ESto es por que la nueva mini tiene evento diferente con el de NavLink
    if (FlagEventMini.getFromMini() && EpgPersistence.isEnabled()) {
      e.preventDefault();
      FlagEventMini.setFromMini(false);
    } else {
      this.sendMetric('buscar');
      if (window.location.href.indexOf('/search') > -1) {
        e.stopPropagation();
        e.preventDefault();
        return;
      }
    }
  };

  Nav = ({ nodes = [], index, setSelected, actives, pathAvatarImg }) => {
    const length = nodes.length;
    const navItems = nodes.map((node, position) =>
      this.NavItem({ node, index, setSelected, actives, position, length })
    );

    navItems.push(this.avatarNavItem(pathAvatarImg));
    navItems.unshift(this.searchNavItem());


    return (
      <ul key={index} className={`nav`}>
        {navItems}
      </ul>
    );
  };

  searchNavItem = () => {
    const activeClassName = `${this.isInSearch()? 'active' : ''}`
    return (
      <li
        key='Search'
        id='search'
      >
        <NavLink
          id="search"
          key={'search'}
          className={`menu-btn-search focusable ${activeClassName}`}
          to={`/search`}
          onClick={(e) => {
            this.hideAlert();
          }}
        >
          <i className="fa fa-search" />
        </NavLink>
      </li>
    );
  }

  avatarNavItem = (pathAvatarImg) =>{

    return (
      <li
        key='Avatar'
        id='avatar'
      >
        <Avatar
          urlImg={pathAvatarImg}
          onClick={this.onAvatarClikHandler}
          width='40px'
          height='40px'
        />
      </li>
    );

  }

  changeMenuImage(code, imgSrc, isImageMenu ){
    if (isImageMenu){
      let menuItem = document.getElementById(code)
      if (menuItem){
        menuItem = menuItem.getElementsByTagName('img');
        if (menuItem && menuItem[0]) {
          const MenuItemImage = menuItem[0];
          MenuItemImage.src = imgSrc;
        }
      }
    }
  }


  NavItem = ({ node, index, setSelected, actives, position, length }) => {
    let nodeValue;
    let isImageMenu = false;
    const iconMenu = Assets.get(`ic_imgmenu_${node.code}`);
    const iconMenuFocused = Assets.get(`ic_imgmenu_${node.code}_focused`);
    const active = this.isInSearch() ? '' : ((actives.length == 0 && node.code === 'homeuser' ) || (actives.find(it => it.code === node.code)) ? 'active' : '');

    if (iconMenu !== `ic_imgmenu_${node.code}`) {
      nodeValue = <img src={active?iconMenuFocused:iconMenu} className="nav-image" alt={node.text} />;
      isImageMenu = true;
    } else {
      nodeValue = node.text;
    }

    const level = node.level;
    const idItem = `${node.id_parent}_${position}`;
    return (
      <li
        key={node.id}
        id={idItem}
        onClick={e => {
          setSelected(node);
          this.menuOnFocusLastPosition = this.menuOnFocusPosition;
        }}
        onFocus={e => {

          this.changeMenuImage(node.code, iconMenuFocused, isImageMenu && !active);

          if (this.menuWidth > 1280) {
            const marginLeft = document
              .getElementById(idItem)
              .getAttribute('data-marginLeft');
            if (marginLeft !== null) {
              document.getElementById(
                idItem
              ).parentNode.style.marginLeft = `-${marginLeft}px`;
              this.menuOnFocusPosition = marginLeft;
            }
          }
          if (this.menuOnBlur) {
            clearTimeout(this.menuOnBlur);
          }
          if (position <= 1) {
            document.getElementById(idItem).parentNode.scrollLeft = 0;
          }
          if (position >= length - 2) {
            document.getElementById(
              idItem
            ).parentNode.scrollLeft = document.getElementById(
              idItem
            ).parentNode.offsetWidth;
          }
        }}
        onBlur={() => {

          this.changeMenuImage(node.code, iconMenu, isImageMenu && !active);

          if (this.menuWidth > 1280) {
            this.menuOnBlur = setTimeout(() => {
              const marginLeft = document
                .getElementById(idItem)
                .getAttribute('data-marginLeft');
              if (marginLeft !== null) {
                document.getElementById(
                  idItem
                ).parentNode.style.marginLeft = `-${this.menuOnFocusLastPosition}px`;
              }
            }, 400);
          }
        }}
      >
        <NavLink
          id={node.code}
          className={`nav-item ${focusSettings.className} ${active}`}
          to={`/node/${node.code}`}
          data-level={level - 1}
          data-focused-level={index}
          title={isImageMenu ? '' : node.text}
        >
          {nodeValue}
        </NavLink>
      </li>
    );
  };

  getNavMenu(menu, pathAvatarImg) {
    return (
      <nav className="nav-container down">
        {this.Nav({
          nodes: menu,
          index: 1,
          setSelected: this.setSelected,
          actives: this.actives,
          pathAvatarImg: pathAvatarImg
        })}
      </nav>
    );
  }


  handleMenuFocus({id, imgSrc, isImageMenu, isActive}){
    this.changeMenuImage(id, imgSrc, isImageMenu && !isActive);
    const el = document.getElementById(id)
      if(el && typeof el.scrollIntoView === 'function'){
          //el.scrollIntoView({inline: "start"});
          el.scrollIntoView(false);
      }
    this.MenuScrollFix({id, el})
  }

  MenuScrollFix({id, el}){

    const rightMax = 1000;
    const LeftMin = 220;
    const menuContainer = document.getElementById('aaf_menu-container-center');

    if (el && menuContainer){
      const [firstElement, ...rest] = el.getClientRects() || [];
      const {left, right} = firstElement;


      const firstMenuItem = menuContainer.querySelector('.aaf_menu-button:first-child a.menu-item')
      const lastMenuItem = menuContainer.querySelector('.aaf_menu-button:last-child a.menu-item')


      if (right>rightMax){
        //ajuste a la derecha
        menuContainer.scrollLeft = menuContainer.scrollLeft - (rightMax - right);
      }

      if (left<LeftMin){
        //ajuste dinamico a la izquierda con un tope minimo
        menuContainer.scrollLeft = menuContainer.scrollLeft - (LeftMin + left);
      }

      if (left<menuContainer.scrollLeft){
        //ajuste a la izquierda
        menuContainer.scrollLeft = menuContainer.scrollLeft - (menuContainer.scrollLeft - left);
      }

      if (el && el.parentNode) {
        const [firstElementParent, ...rest] = el.parentNode.getClientRects() || [];
        const {left: leftParent} = firstElementParent;
        if (leftParent <= LeftMin) {
          //Se ajusta a la izquierda sobre el parent
          menuContainer.scrollLeft = LeftMin - leftParent;
        }
      }

      if(firstMenuItem && firstMenuItem.hasAttribute('id')) {
        const firstMenuId = firstMenuItem.getAttribute('id')
        if(firstMenuId === id){
          menuContainer.scrollLeft = 0;
        }
      }

      if(lastMenuItem && lastMenuItem.hasAttribute('id')) {
        const lastMenuId = lastMenuItem.getAttribute('id')
        if(lastMenuId === id){
          const maxScrollLeft = menuContainer.scrollWidth - menuContainer.clientWidth;
          menuContainer.scrollLeft = maxScrollLeft;
        }
      }
    }
  }

  handleMenuBlur({id, imgSrc, isImageMenu, isActive}){
    this.changeMenuImage(id, imgSrc, isImageMenu && !isActive);
  }

  handleImageLoad = () => {
    LayersControl.centerAAFMenu();
  };

  getNavItems(menu){
    let navItems = [];
    if (Array.isArray(menu) ) {
      /**
       * @param {Array} menu
       * only hide qatar node
       */
      menu = getShowSoccerWorldCupNode(menu);
      navItems = menu.map(({id, text, menu_id, code, app_behaviour, childs} )=>{

        let nodeTo = `/node/${code}`;
        

        const iconKey = `ic_imgmenu_${code}`
        const iconMenu = Assets.get(iconKey);
        const iconMenuFocused = Assets.get(`${iconKey}_focused`);
        const isActive = this.isInSearch() ? '' : ((this.actives.length === 0 && code === 'homeuser' ) || (this.actives.find(it => it.code === code)) ? 'active' : '');
        let nodeValue = text, isImageMenu = false, isImageMenuFocused = false;

        if (iconMenu !== iconKey) {
          nodeValue = <img src={isActive?iconMenuFocused:iconMenu} className="nav-image" alt={text} onLoad={this.handleImageLoad}/>;
          isImageMenu = true;
        }
        if (iconMenuFocused !== iconKey) {
          isImageMenuFocused = true;
        }

        return {
          id: id,
          key: menu_id,
          value: nodeValue,
          title: text,
          nodeTo,
          className: 'regular',
          isActive,
          isImage: isImageMenu,
          onFocus: ()=>{this.handleMenuFocus({
            id: `menu-${id}`,
            code,
            isImageMenu,
            imgSrc: iconMenuFocused,
            isActive,
          })},
          onBlur:()=>{
            this.handleMenuBlur({
              id: `menu-${id}`,
              code,
              isImageMenu: isImageMenuFocused,
              imgSrc: iconMenu,
              isActive,
            })
          },
          direction:{
            down: '.container a.focusable'
          }
        }
      });
    }

    return navItems;

  }

  isInSearch(){
    return this.props.history.location.pathname.indexOf('search')!==-1;
  }

  isInMusic(){
    return this.props.history.location.pathname.indexOf('playlist')!==-1;
  }

  showAlertUserSuc(){
    const payWayUser = store && store.getState().user &&
                       store.getState().user.paymentMethods &&
                      store.getState().user.paymentMethods.telmexmexicogate;

    const user = store && store.getState().user;
    const isSuscC = user && user.hasUserSusc ? user.hasUserSusc : this.props.user.isSusc;

    if (Utils.getForceNoHeaderBlueBand()){
      return false;
    } else {
      let {validEmail} =  this.props.user || {};
      const { navbar: { nodes } } = store.getState();
      const homeNode = (nodes && nodes[0] && nodes[0].code) || HOMEUSER;
      const shouldBeShown =
        (  this.props.initialRoute.toLowerCase() === homeNode)&&
        !UtilsIsLoggedIn.userType() &&
        this.props.user.isLoggedIn &&
        this.state.isAlertVisible &&
        (!AdsUtils.isAdsEnable() || (AdsUtils.isAdsEnable() && payWayUser));
      if (shouldBeShown) {
        const validation = (
          !isSuscC &&
          !this.isInMusic()
        ) || (!validEmail);
        return validation;
      } else {
        return false;
      }
    }
  }

  isHomeNode = () => {
    const { navbar: { nodes } } = store.getState();
    const homeNode = (nodes && nodes[0] && nodes[0].code) || HOMEUSER;
    return this.props.initialRoute.toLowerCase() === homeNode;
  }

  findNode(nodes, code) {
    if(nodes && Array.isArray(nodes)){
      return nodes.find((node)=>node.code === code);
    }
  }

  render() {
    this.setActiveElements();
    let newUser;
    this.isAnonymousStart = this.props.user.isAnonymous;
    this.isAnonymousH2 = this.state.isAnonymousH;

    if(!this.isAnonymousStart && this.props.user.isLoggedIn && !this.isAnonymousH2){
      this.nodes = Utils.filterNavNodes(this.getVisibleNodes(this.props.nodes,));
      this.allNodes = this.getAllNodes( this.nodes);
      const navcodes = this.allNodes.map(x => x.code);
      new ActivesSingleton().setNav(navcodes);
      this.isAnonymousStart = false;
      this.navNodesExtra();
      this.setState({ isAnonymousH: true });
    }

    if (!this.props.user.isLoggedIn) newUser = { metadatas: { facebookId: null } };
    else if (
      this.props.user &&
      this.props.user.socialNetworks &&
      this.props.user.socialNetworks.filter
    ) {
      const withFace = this.props.user.socialNetworks.filter(
        x => x.extra_data && x.extra_data.id
      )[0];

      if (withFace) newUser = { metadatas: { facebookId: withFace.extra_data.id } };
    }

    if (this.props.user.isLoggedIn) {
      const profile = this.props.profile;
      if (UtilsProfile.isProfileEnable(this.props.user)) {

        if (newUser) {
          newUser.profile_image = profile.user_image ? `${profile.user_image}&impolicy=resize&vwidth=40` : null;
        } else {
          newUser = { profile_image: profile.user_image ? `${profile.user_image}&impolicy=resize&vwidth=40` : null };
        }
      } else {
        newUser = { profile_image: profile.user_image ? `${profile.user_image}&impolicy=resize&vwidth=40` : null };
      }
    }

    const { menu } = this.state;
    const headerLogo =
      (this.props.history.location.pathname.indexOf('claromusica') !== -1 ||
       this.props.history.location.pathname.indexOf('playlist') !== -1 ||
       this.props.history.location.pathname.indexOf('radio') !== -1)
        ? Assets.get('claro_musica_logo')
        : Assets.get('logo_clarotv', clarotv_logo);

    const widthHeaderLogo =
      this.props.history.location.pathname.indexOf('claromusica') !== -1 ? '151' : '156';
    //TODO  cambiar este meteodo
    const logo = { imageLogo: headerLogo, className: 'claro-video-logo' }
    const pathAvatarImg = newUser.profile_image;
    const {nodes = []}=this.props;
    if(nodes && Array.isArray(nodes)){
      const claroMusicNode = this.findNode(Utils.filterNavNodes(nodes), CLARO_MUSICA_NODE);
      Utils.setHasClaroMusicaNode((typeof claroMusicNode === 'object'));
    }

    const hasNodeCM = Utils.getHasClaroMusicaNode();

    if (Utils.isVisibleAlertHeaderBelt() && !this.state.setChangeVisibilyAlertBelt) {
      console.log('[angeel] Hidden Alert Header')
      this.changesVisibilityAlertBelt();
    }

    return (
      <header id="header" className="header">
        <div id="header-cintillo" className="header-cintillo">
          {
              this.centerNotificationEnabled && this.isHomeNode()
              ? <CenterNotification />
              : (
                <Alert
                  dissmisible={true}
                  onOkClick={() => { this.onClickAlert() }}
                  onCloseClick={() => { this.hideAlert(true) }}
                  okButtonText={Translator.get('home_ticker_option_button_next', 'OK')}
                  closeButtonText={Translator.get('home_ticker_option_button_cancel', 'CERRAR')}
                  visible={this.showAlertUserSuc()}>
                  {this.getAlertMessage()}
                </Alert>
              )
          }

        </div>
        <div className="header-container" ref={nav => (this.headerContainerRef = nav)}>
          <AAFMenu
            className={`${Device.getDevice().getPlatform()} header-top header-new ${hasNodeCM?'move-menu-rigth':''}`}
            menuItems={this.getNavItems(menu)}
            logo={logo}
            leftItem={{
              id: 'search',
              key: '0',
              value: '',
              title: 'busqueda',
              nodeTo: `/search`,
              className: 'search'
            }}
            rightItem={{
              id: 'avatar',
              className: 'avatar',
              children: <Avatar
                className='avatar'
                urlImg={pathAvatarImg}
                onClick={this.onAvatarClikHandler}
                width='40px'
                height='40px'/>
            }}
          />
        </div>
      </header>
    );
  }
}

export const getLinksFromNavConfiguration = () => {
  return Utils.getApaMetadataKey('links_nav_configuration',
    Utils.mock_links_nav_configuration())
};

const mapStateToProps = (state) => ({
  navbarNodes: state && state.navbar.nodes,
  isOpen: state.centerNotifications.isOpen
});

export default connect(
  mapStateToProps,
  {
    showModal,
    setMetricsEvent,
    fetchLinealChannels,
    receiveIsLoggedIn,
    playFullMedia,
    flagAlertBelt,
    toggleNotification
  }
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx